import EmpHeaderSection from "../app/pannels/employer/common/emp-header";
import EmpSidebarSection from "../app/pannels/employer/common/emp-sidebar";
import YesNoPopup from "../app/common/popups/popup-yes-no";
import EmployerRoutes from "../routing/employer-routes";
import { popupType } from "../globals/constants";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { admin, adminRoute, publicUser } from "../globals/route-names";
import AdminImpersonationBanner from "../app/common/admin-impersonation-banner";

function EmployerLayout() {

    const [sidebarActive, setSidebarActive] = useState(true);
    const { user, loading } = useAuth();

    const handleSidebarCollapse = () => {
        setSidebarActive(!sidebarActive);
    }

    if (loading) return <div className="p-a30 text-center">Loading account...</div>;
    if (!user) return <Navigate to={publicUser.pages.LOGIN} replace />;
    if (user.role === "admin") return <Navigate to={adminRoute(admin.DASHBOARD)} replace />;
    if (user.role !== "employer") return <Navigate to={publicUser.pages.LOGIN} replace />;

    return (
        <>
            <div className="page-wraper">

                <EmpHeaderSection onClick={handleSidebarCollapse} sidebarActive={sidebarActive} />
                <AdminImpersonationBanner />
                <EmpSidebarSection sidebarActive={sidebarActive} />

                <div id="content" className={sidebarActive ? "" : "active"}>
                    <div className="content-admin-main">
                        <EmployerRoutes />
                    </div>
                </div>

                <YesNoPopup id="delete-dash-profile" type={popupType.DELETE} msg={"Do you want to delete your profile?"} />
                <YesNoPopup id="logout-dash-profile" type={popupType.LOGOUT} msg={"Do you want to Logout your profile?"} />

            </div>
        </>
    )
}

export default EmployerLayout;
